import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { NotificationProvider } from "./hooks/useNotifications";
import { WebSocketProvider } from "./hooks/useWebSocket";
import reportWebVitals from "./reportWebVitals";

// Prevent scrolling around in the chat on page (re-) load
window.history.scrollRestoration = "manual";

const initialState = JSON.parse(
  document.getElementById("initial-state").textContent
);

const webSocketUrl =
  (window.location.protocol === "https:" ? "wss://" : "ws://") +
  window.location.host +
  "/" +
  initialState.room.wsaddr;

ReactDOM.render(
  <React.StrictMode>
    <NotificationProvider initial={initialState.messages}>
      <WebSocketProvider
        webSocketUrl={webSocketUrl}
        heartbeat={initialState.room.heartbeat}
      >
        <App {...initialState} />
      </WebSocketProvider>
    </NotificationProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
